<template>
    <div style="display:inline">
        <select name="country_id"  v-model="country_id" @change="get_cities" ref = "country_id_ref" :class="ele_class">
            <option hidden value="">{{ translations.country }}</option>
            <option v-if="disable_all_option != 'true'" value="">{{ translations.all_countries }}</option>
            <option v-for="country in countries" :key="country.id" :value="country.id">{{country.name}}</option>
        </select>
    </div>
</template>

<script>
    export default {
        props:[
                'get_countries_url',
                'option_null',
                'ele_class',
                'init_country_id',
                'disable_all_option',
            ],
        data() {
            return {
                countries: {},
                country_id: '',
                lang: window.current_locale
            };
        },
        computed: {
            translations() {
                const translations = {
                    ar: {
                        country: 'الدولة',
                        all_countries: 'كل الدول'
                    },
                    en: {
                        country: 'Country',
                        all_countries: 'All Countries'
                    }
                };
                
                return translations[this.lang] || translations.ar;
            }
        },
        methods: {
            get_countries(){
                axios.get(this.get_countries_url, { params: { lang: window.current_locale } })
                    .then((response) => (this.countries = response.data));
            },
            get_cities(){
                this.$parent.$refs.cities_component_ref.city_id= ''
                this.$parent.$refs.cities_component_ref.get_cities(this.country_id)
            }
        },
        mounted() {
            this.get_countries();
            const queryString = window.location.search;
            const urlParams = new URLSearchParams(queryString);
            const country_id_url = urlParams.get('country_id');
            if(country_id_url != null){
                this.country_id = country_id_url;
            }

            if(this.init_country_id){
                this.country_id = this.init_country_id
            }
        },
        
    };
</script>